import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { LanguageAssessmentStatus } from './language-assessment-status';
import { LanguageAssessmentType } from './language-assessment-type';

@inheritSerialization(AbstractModel)
export class LanguageProficiencyScreening extends AbstractModel {
  @autoserialize
  screeningId: number;

  @autoserialize
  driverId: number;

  @autoserialize
  candidateAssessmentId: string;

  @autoserialize
  assessmentInvitationUrl: string;

  @autoserializeAs(Date)
  startedAt: Date;

  @autoserializeAs(Date)
  completedAt: Date;

  @autoserializeAs(LanguageAssessmentStatus)
  assessmentCompletionStatus: LanguageAssessmentStatus;

  @autoserialize
  timeSpent: number;

  @autoserialize
  score: number;

  @autoserialize
  geolocationCheatingDetected: boolean;

  @autoserialize
  plagiarismDetected: boolean;

  @autoserializeAs(LanguageAssessmentType)
  languageAssessmentType: LanguageAssessmentType;

  @autoserialize
  active: boolean;

  static OnSerialized(instance: LanguageProficiencyScreening, json: any): void {
    if (!isNullOrUndefined(instance.startedAt)) {
      json.startedAt = DateUtil.serializeDate(instance.startedAt);
    }

    if (!isNullOrUndefined(instance.completedAt)) {
      json.completedAt = DateUtil.serializeLocalDate(instance.completedAt);
    }
  }

  static OnDeserialized(instance: LanguageProficiencyScreening, json: any): void {
    if (!isNullOrUndefined(json['startedAt'])) {
      instance.startedAt = DateUtil.deserializeDate(json['startedAt']);
    }

    if (!isNullOrUndefined(json['completedAt'])) {
      instance.completedAt = DateUtil.deserializeLocalDate(json['completedAt']);
    }
  }
}
